'use client';

import { createContext, useMemo, useState } from 'react';
import { PopTopicTagKey, PopTopicCategories } from '@fe-news/constants/pop-topic/type';

export type PopTopicCategoryContextValue = {
  category: PopTopicTagKey;
  setCategory?: React.Dispatch<React.SetStateAction<PopTopicTagKey>>;
  keyword: string;
  setKeyword?: React.Dispatch<React.SetStateAction<string>>;
};

export const PopTopicContext = createContext<PopTopicCategoryContextValue>({
  category: PopTopicCategories.ALL,
  setCategory: undefined,
  keyword: '',
  setKeyword: undefined
});

type CategoryProviderPros = {
  children: React.ReactNode;
};

export default function PopTopicProvider({ children }: CategoryProviderPros) {
  const [category, setCategory] = useState<PopTopicTagKey>(PopTopicCategories.ALL);
  const [keyword, setKeyword] = useState<string>('');

  const value = useMemo(
    () => ({
      category,
      setCategory,
      keyword,
      setKeyword
    }),
    [category, setCategory, keyword, setKeyword]
  );

  return <PopTopicContext.Provider value={value}>{children}</PopTopicContext.Provider>;
}
